import { useContext, useEffect } from 'react'

import { useFetch } from '@reveni-io/reveni-ui'

import AppContext from '@/context/AppContext'
import services from '@/services/services'

const useSuccess = ({ orderId, returnId }) => {
  const { setContext } = useContext(AppContext)
  const { data, loading } = useFetch(services.getReturn, {
    doInitialRequest: true,
    params: { orderId, returnId },
  })

  useEffect(() => {
    if (data) {
      setContext(context => ({
        ...context,

        orderInfo: {
          ...context.orderInfo,
          orderId: data?.order_id,
          returnId: data?.id,
        },
        merchantInfo: {
          ...context.merchantInfo,
          ...data.portal,
        },
      }))
    }
  }, [data, setContext])

  return { data, loading }
}

export default useSuccess
